import { render, staticRenderFns } from "./ProductPicture.vue?vue&type=template&id=c5c58494&scoped=true&"
import script from "./ProductPicture.vue?vue&type=script&lang=js&"
export * from "./ProductPicture.vue?vue&type=script&lang=js&"
import style0 from "./ProductPicture.vue?vue&type=style&index=0&id=c5c58494&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c58494",
  null
  
)

export default component.exports